import type { AnyFormState } from '@tanstack/react-form';

import { Block } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { useFormContext } from '../../hooks/use-form-context';

export function AutoSubmitBlocker() {
    const form = useFormContext();
    // We need to prevent multiple submissions if the effect runs multiple times
    const isSubmittingRef = useRef(false);

    return (
        <form.Subscribe
            selector={state => ({
                isDirty: state.isDirty,
            })}
        >
            {({ isDirty }) => (
                <Block
                    shouldBlockFn={() => isDirty}
                    withResolver
                    enableBeforeUnload={false}
                >
                    {({ status, proceed, reset }) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            if (status === 'blocked' && !isSubmittingRef.current) {
                                const handleSubmit = async () => {
                                    isSubmittingRef.current = true;
                                    await form.handleSubmit();

                                    const state = form.store.state as AnyFormState;

                                    const hasFieldErrors = Object.keys(state.fieldMeta).some((key) => {
                                        const fieldKey = key as keyof typeof state.fieldMeta;
                                        const fieldMeta = state.fieldMeta[fieldKey];

                                        if (!fieldMeta) {
                                            console.warn(`[Form Fields V2] Field meta not found for key: ${fieldKey}`);
                                            return false;
                                        }

                                        return fieldMeta.errors.length > 0;
                                    });

                                    const hasFormErrors = state.errors.length > 0;

                                    if (hasFieldErrors || hasFormErrors) {
                                        reset();
                                    }
                                    else {
                                        proceed();
                                    }

                                    isSubmittingRef.current = false;
                                };
                                handleSubmit();
                            }
                        }, [status, proceed, reset]);

                        return null;
                    }}
                </Block>
            )}
        </form.Subscribe>
    );
}
